// extracted by mini-css-extract-plugin
module.exports = {"myOrdersContainer":"MyOrders_myOrdersContainer__TvPTi","ordersTable":"MyOrders_ordersTable__33MFP","button":"MyOrders_button__2xXMi"};